






























































import { Component, Vue } from 'vue-property-decorator'

import { esia } from '@/store/modules/esia'
import { mock } from '@/tools'
import { security } from '@/store/modules/security'

@Component
class LoginView extends Vue {
  esiaModule = esia.context(this.$store)
  securityModule = security.context(this.$store)

  get psuLink() {
    return process.env.VUE_APP_PSU_LINK
  }

  async created() {
    if (!this.$route.query.state || !this.$route.query.code) return
    try {
      await this.esiaModule.actions.login({
        state: this.$route.query.state as string,
        code: this.$route.query.code as string,
      })

      await this.$router.replace({ name: 'main' })
    } catch (error) {
      mock(error)
    }
  }

  async mounted() {
    if (!this.securityModule.state.cabinetAccess) {
      try {
        await this.securityModule.actions.checkCabinetAccess()
        if (this.securityModule.state.cabinetAccess) {
          await this.$router.replace({ name: 'main' })
        }
      } catch (error) {
        mock(error)
      }
    }
  }

  async redirect() {
    try {
      location.href = await this.esiaModule.actions.getRedirectLink()
    } catch (error) {
      mock(error)
    }
  }
}

export default LoginView
